import script from "./shenpishijuan.vue?vue&type=script&setup=true&lang=js"
export * from "./shenpishijuan.vue?vue&type=script&setup=true&lang=js"

import "./shenpishijuan.vue?vue&type=style&index=0&id=7393bf0e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7393bf0e"]])

export default __exports__